import React from 'react'
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import Switch from 'react-bootstrap-switch'
import {
  FormControl,
  FormLabel,
  FormGroup as MuiFormGroup,
  Checkbox,
  FormControlLabel,
  TextField,
  Autocomplete,
} from '@mui/material'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import moment from 'moment-timezone'
import 'moment/locale/fi'
import TinyEditor from '../Editor/TinyEditor'
import { v4 as uuidv4 } from 'uuid'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { DEFAULT_SPORTS } from '../../sports'

const localizer = momentLocalizer(moment)
const DnDCalendar = withDragAndDrop(Calendar)

const weekdaysAsResources = [
  { resourceId: 1, resourceTitle: 'Maanantai' },
  { resourceId: 2, resourceTitle: 'Tiistai' },
  { resourceId: 3, resourceTitle: 'Keskiviikko' },
  { resourceId: 4, resourceTitle: 'Torstai' },
  { resourceId: 5, resourceTitle: 'Perjantai' },
  { resourceId: 6, resourceTitle: 'Lauantai' },
  { resourceId: 7, resourceTitle: 'Sunnuntai' },
]

const SOURCE_TYPES = [
  { value: 'reservation', label: 'Varaukset' },
  { value: 'activity', label: 'Aktiviteetit' },
]

const ScheduleToolbar = () => <></>

const INIT_TEMPLATE = {
  source: 'reservation',
  venue: 'all',
  lang: 'all',
  channel: 'mail',
  memberships: [],
  enabled: true,
  default: false,
  category: 'all',
  schedule: [],
  resources: [],
  sports: [],
  message: {
    subject: '',
    body: '',
    htmlbody: '',
  },
}

function formatSchedule(schedule) {
  return schedule.map((s) => ({
    id: s.id,
    start: moment('1970-01-01 ' + s.start).toDate(),
    end: moment('1970-01-01 ' + s.end).toDate(),
    resourceId: s.day,
  }))
}

function FirstPurchaseMessageRow(props) {
  const {
    index: i,
    template,
    openEditMessageModal,
    openEditScheduleModal,
    openEditResourcesModal,
    openEditSportsModal,
    updateTemplateName,
    updateTemplateSource,
    updateTemplateEnabled,
  } = props

  const isReservation = (template.source || 'reservation') === 'reservation'

  return (
    <Row key={i} style={{ borderTop: '1px solid rgba(0, 0, 0, 0.10)', paddingTop: 15, paddingBottom: 5 }}>
      <Col md='3' xs='12'>
        <Autocomplete
          id={'source.' + i}
          options={SOURCE_TYPES}
          getOptionLabel={(o) => o.label || ''}
          isOptionEqualToValue={(o, v) => o.value === v.value}
          value={SOURCE_TYPES.find((x) => x.value === (template.source || 'reservation')) || null}
          onChange={(_e, val) => updateTemplateSource(val || SOURCE_TYPES[0])}
          disableClearable
          renderInput={(params) => (
            <TextField {...params} label='Lähde' variant='standard' fullWidth />
          )}
        />
      </Col>
      <Col md='1' xs='12'>
        <Label for={'enabled.' + i}>Käytössä</Label>{' '}
        <div name={'enabled.' + i}>
          <Switch
            defaultValue={template.enabled || false}
            onColor='primary'
            offColor='primary'
            id={'enabled.' + i}
            name={'enabled.' + i}
            onChange={(e, s) => updateTemplateEnabled(s)}
          />
        </div>
      </Col>
      <Col md='3' xs='12' style={{ paddingRight: 30 }}>
        <TextField
          fullWidth
          id={'displayName.' + i}
          label='Nimi'
          value={template.displayName ? template.displayName : ''}
          onChange={updateTemplateName}
        />
      </Col>
      <Col>
        <Button color={'success'} onClick={() => openEditMessageModal(i)}>
          Viesti
        </Button>
        <Button color={'success'} onClick={() => openEditScheduleModal(i)} disabled={!isReservation}>
          Aikataulu
        </Button>
        {isReservation ? (
          <Button color={'success'} onClick={() => openEditResourcesModal(i)}>
            Resurssit
          </Button>
        ) : (
          <Button color={'success'} onClick={() => openEditSportsModal(i)}>
            Lajit
          </Button>
        )}
      </Col>
    </Row>
  )
}

class FirstPurchaseMessageTemps extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstpurchase: [],
      resourcecategories: [],
      resources: [],
      categoryOptions: [],
      loadingTemplates: true,
      loadingCategories: true,
      loadingResources: true,
      saved: true,
      showMessageModal: false,
      showScheduleModal: false,
      showResourcesModal: false,
      showSportsModal: false,
      selectedIndex: -1,
      showDynamicHelp: false,
    }
  }

  componentDidMount() {
    this.unsubscribe = this.props.firebase.getMessageTemplates().onSnapshot((doc) => {
      if (doc.exists) {
        this.setState({
          firstpurchase: doc.data().firstpurchase || [],
          loadingTemplates: false,
        })
      } else {
        this.setState({
          loadingTemplates: false,
          firstpurchase: [],
        })
      }
    })
    this.unsubscribeCats = this.props.firebase.getResourceCategories().onSnapshot((doc) => {
      if (doc.exists) {
        const resourcecategories = doc.data().categories
        const _categoryOptions = resourcecategories.map((rc) => ({
          value: rc.category.toLowerCase(),
          label: rc.category,
        }))
        _categoryOptions.push({ value: 'all', label: 'Kaikki' })
        this.setState({
          resourcecategories,
          categoryOptions: _categoryOptions,
          loadingCategories: false,
        })
      } else {
        this.setState({ loadingCategories: false })
      }
    })
    this.props.firebase.getResourses().then((_resources) => {
      const resources = _resources.docs
        .map((sh) => ({ ...sh.data(), id: sh.id }))
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
      this.setState({
        resources: resources || [],
        loadingResources: false,
      })
    })
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
    if (this.unsubscribeCats) this.unsubscribeCats()
  }

  addRow = () => {
    let j = this.state.firstpurchase
    j.push(JSON.parse(JSON.stringify(INIT_TEMPLATE)))
    this.setState({ firstpurchase: j, saved: false })
  }

  removeRow = (index) => {
    if (!window.confirm('Poista viesti?')) return
    const j = this.state.firstpurchase.filter((_, i) => i !== index)
    this.setState({ firstpurchase: j, saved: false })
  }

  toggleMessage = () => this.setState({ showMessageModal: !this.state.showMessageModal })
  toggleSchedule = () => this.setState({ showScheduleModal: !this.state.showScheduleModal })
  toggleResources = () => this.setState({ showResourcesModal: !this.state.showResourcesModal })
  toggleSports = () => this.setState({ showSportsModal: !this.state.showSportsModal })
  toggleDynamicHelp = () => this.setState({ showDynamicHelp: !this.state.showDynamicHelp })

  setCategory = (selection) => {
    let _a = this.state.firstpurchase
    _a[this.state.selectedIndex].category = selection.value
    this.setState({ firstpurchase: _a, saved: false })
  }

  handleMessageBodyChange = (html) => {
    let j = this.state.firstpurchase
    if (!j[this.state.selectedIndex].message) j[this.state.selectedIndex].message = { htmlbody: '', subject: '' }
    j[this.state.selectedIndex].message.htmlbody = html
    delete j[this.state.selectedIndex].message.body
    this.setState({ firstpurchase: j, saved: false })
  }

  handleMessageSubjectChange = (e) => {
    let j = this.state.firstpurchase
    if (!j[this.state.selectedIndex].message) j[this.state.selectedIndex].message = { body: '', subject: '' }
    j[this.state.selectedIndex].message.subject = e.target.value
    this.setState({ firstpurchase: j, saved: false })
  }

  handleResourceChange = (e) => {
    let j = this.state.firstpurchase
    if (!j[this.state.selectedIndex].resources) j[this.state.selectedIndex].resources = []
    if (e.target.checked) {
      j[this.state.selectedIndex].resources.push(e.target.name)
    } else {
      j[this.state.selectedIndex].resources = j[this.state.selectedIndex].resources.filter((x) => x !== e.target.name)
    }
    this.setState({ firstpurchase: j, saved: false })
  }

  handleSportsChange = (_event, value) => {
    let j = this.state.firstpurchase
    j[this.state.selectedIndex].sports = (value || []).map((v) => v.key)
    this.setState({ firstpurchase: j, saved: false })
  }

  onSave = (event) => {
    event.preventDefault()
    const _rows = this.state.firstpurchase.map((r) => {
      delete r.empty
      return r
    })
    this.props.firebase.addMessageTemplates({ firstpurchase: _rows }).then(() => {
      this.setState({ saved: true })
    })
  }

  handleSelectEvent = (event) => {
    if (window.confirm('Poista ?')) {
      let j = this.state.firstpurchase
      j[this.state.selectedIndex].schedule = j[this.state.selectedIndex].schedule.filter((e) => e.id !== event.id)
      this.setState({ firstpurchase: j, saved: false })
    }
  }

  handleSelectSlot = (slotInfo) => {
    let s = moment(slotInfo.start)
    let e = moment(slotInfo.end)
    if (e.diff(s, 'minutes') < 30) e = moment(s).add(30, 'minutes')
    const _ePlaceholder = {
      id: uuidv4(),
      start: s.format('HH:mm'),
      end: e.format('HH:mm'),
      day: slotInfo.resourceId,
    }
    let j = this.state.firstpurchase
    if (!j[this.state.selectedIndex].schedule) j[this.state.selectedIndex].schedule = []
    j[this.state.selectedIndex].schedule.push(_ePlaceholder)
    this.setState({ firstpurchase: j, saved: false })
  }

  moveEvent = ({ event, start, end, resourceId }) => {
    let j = this.state.firstpurchase
    j[this.state.selectedIndex].schedule = j[this.state.selectedIndex].schedule.map((e) => {
      if (e.id === event.id) {
        const _s = moment(start)
        const _e = moment(end)
        return { ...e, start: _s.format('HH:mm'), end: _e.format('HH:mm'), day: resourceId }
      }
      return e
    })
    this.setState({ firstpurchase: j, saved: false })
  }

  resizeEvent = ({ event, start, end }) => {
    let j = this.state.firstpurchase
    j[this.state.selectedIndex].schedule = j[this.state.selectedIndex].schedule.map((e) => {
      if (e.id === event.id) {
        const _s = moment(start)
        const _e = moment(end)
        return { ...e, start: _s.format('HH:mm'), end: _e.format('HH:mm') }
      }
      return e
    })
    this.setState({ firstpurchase: j, saved: false })
  }

  render() {
    if (this.state.loadingCategories || this.state.loadingTemplates) return <></>
    const selected = this.state.firstpurchase[this.state.selectedIndex]
    const selectedSports = (selected?.sports || [])
      .map((k) => DEFAULT_SPORTS.find((s) => s.key === k))
      .filter(Boolean)
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <Card>
                <CardHeader>
                  <Row>
                    <Col lg='10' md='5' sm='5'>
                      <CardTitle tag='h5'>Ensiostoviestit</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {this.state.firstpurchase.map((c, i) => (
                    <FirstPurchaseMessageRow
                      key={i}
                      index={i}
                      template={c}
                      openEditMessageModal={() => {
                        this.setState({ selectedIndex: i })
                        this.toggleMessage()
                      }}
                      openEditScheduleModal={() => {
                        this.setState({ selectedIndex: i })
                        this.toggleSchedule()
                      }}
                      openEditResourcesModal={() => {
                        this.setState({ selectedIndex: i })
                        this.toggleResources()
                      }}
                      openEditSportsModal={() => {
                        this.setState({ selectedIndex: i })
                        this.toggleSports()
                      }}
                      updateTemplateName={(e) => {
                        let j = this.state.firstpurchase
                        j[i].displayName = e.target.value
                        this.setState({ firstpurchase: j, saved: false })
                      }}
                      updateTemplateSource={(selection) => {
                        let j = this.state.firstpurchase
                        j[i].source = selection.value
                        this.setState({ firstpurchase: j, saved: false })
                      }}
                      updateTemplateEnabled={(value) => {
                        let j = this.state.firstpurchase
                        j[i].enabled = value
                        this.setState({ firstpurchase: j, saved: false })
                      }}
                    />
                  ))}
                  <Row>
                    <Col style={{ marginTop: '20px' }}>
                      <Button className='btn-round btn-icon' color='primary' size='sm' onClick={this.addRow}>
                        <i className='fa fa-plus' />
                      </Button>{' '}
                      Lisää ensiostoviesti
                    </Col>
                  </Row>
                  <Row>
                    <Col className='ml-auto mr-auto' sm='12'>
                      <Button disabled={this.state.saved} color='primary' onClick={this.onSave}>
                        Tallenna muutokset
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Message modal */}
          <Modal isOpen={this.state.showMessageModal} toggle={this.toggleMessage} size='lg'>
            <ModalHeader toggle={this.toggleMessage}>Viesti</ModalHeader>
            <ModalBody>
              <div>
                <Label for='messagetemplates'>Dynaamiset kentät</Label>
                {this.state.showDynamicHelp ? (
                  <KeyboardArrowUpIcon onClick={this.toggleDynamicHelp} />
                ) : (
                  <KeyboardArrowDownIcon onClick={this.toggleDynamicHelp} />
                )}
              </div>
              {this.state.showDynamicHelp ? (
                <div>
                  <Row>
                    <Col>&#123;SUBJECT_SHORT&#125;</Col>
                    <Col>Vakiomuotoinen otsikko</Col>
                  </Row>
                  <Row>
                    <Col>&#123;PERSON_NAME&#125;</Col>
                    <Col>Asiakkaan etu- ja sukunimi</Col>
                  </Row>
                  <Row>
                    <Col>&#123;RESERVATION_DATE_TIME&#125;</Col>
                    <Col>Varauksen päivä ja aika</Col>
                  </Row>
                  <Row>
                    <Col>&#123;RESERVATION_VENUE&#125;</Col>
                    <Col>Paikka</Col>
                  </Row>
                  <Row>
                    <Col>&#123;RESERVATION_COURT&#125;</Col>
                    <Col>Kenttä</Col>
                  </Row>
                  <Row>
                    <Col>&#123;RESERVATION_SPORT&#125;</Col>
                    <Col>Kategoria / laji</Col>
                  </Row>
                  <Row>
                    <Col>&#123;RESERVATION_PRICE&#125;</Col>
                    <Col>Hinta</Col>
                  </Row>
                </div>
              ) : null}

              <FormGroup>
                <Label for='messageSubject'>Otsikko</Label>
                <Input
                  id='messageSubject'
                  value={selected?.message?.subject || ''}
                  name='messageSubject'
                  onChange={this.handleMessageSubjectChange}
                />
              </FormGroup>
              <TinyEditor
                value={
                  selected?.message?.htmlbody
                    ? selected.message.htmlbody
                    : selected?.message?.body
                    ? selected.message.body.replace(/\n/g, '<br/>')
                    : ''
                }
                onChange={this.handleMessageBodyChange}
                onClose={this.handleMessageBodyChange}
                disableSave={true}
              />
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={this.toggleMessage}>
                Sulje
              </Button>
            </ModalFooter>
          </Modal>

          {/* Schedule modal */}
          <Modal isOpen={this.state.showScheduleModal} toggle={this.toggleSchedule} size='xl'>
            <ModalHeader toggle={this.toggleSchedule}>Aikataulu</ModalHeader>
            <ModalBody>
              <Row>
                <Col md='12'>
                  <DnDCalendar
                    style={{ height: '85vh' }}
                    selectable
                    localizer={localizer}
                    events={formatSchedule(selected?.schedule || [])}
                    views={['day']}
                    step={30}
                    min={new Date(1970, 0, 1, 23, 0, 0)}
                    defaultView={Views.DAY}
                    scrollToTime={new Date(1970, 0, 1, 12)}
                    defaultDate={new Date(1970, 0, 1, 12)}
                    onSelectEvent={(event) => this.handleSelectEvent(event)}
                    onSelectSlot={this.handleSelectSlot}
                    components={{ toolbar: ScheduleToolbar }}
                    resources={weekdaysAsResources}
                    resourceIdAccessor='resourceId'
                    resourceTitleAccessor='resourceTitle'
                    draggableAccessor={() => true}
                    onEventDrop={this.moveEvent}
                    onEventResize={this.resizeEvent}
                    resizable
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={this.toggleSchedule}>
                Sulje
              </Button>
            </ModalFooter>
          </Modal>

          {/* Resources modal */}
          <Modal isOpen={this.state.showResourcesModal} toggle={this.toggleResources} size='lg'>
            <ModalHeader toggle={this.toggleResources}>Resurssit</ModalHeader>
            <ModalBody>
              <div>
                <p>Valitse kategoria tai yksittäiset resurssit. Jos yksikin resurssi valittu, niin kategoriaa ei huomioida.</p>
                <div
                  style={{
                    display: selected?.resources && selected.resources.length > 0 ? 'none' : 'block',
                  }}
                >
                  <Autocomplete
                    id={'catlabel'}
                    options={this.state.categoryOptions}
                    getOptionLabel={(o) => o.label || ''}
                    isOptionEqualToValue={(o, v) => o.value === v.value}
                    disabled={selected?.resources && selected.resources.length > 0}
                    value={
                      selected?.category
                        ? this.state.categoryOptions.find((x) => x.value === selected.category) || null
                        : null
                    }
                    onChange={(_e, val) => this.setCategory(val || { value: 'all', label: 'Kaikki' })}
                    disableClearable
                    renderInput={(params) => (
                      <TextField {...params} label='Kategoria' variant='standard' fullWidth />
                    )}
                  />
                </div>
              </div>
              <div>
                <FormControl component='fieldset'>
                  <FormLabel component='legend'>Valitse resurssit</FormLabel>
                  <MuiFormGroup>
                    {this.state.resources.map((r, i) => (
                      <FormControlLabel
                        key={i}
                        control={
                          <Checkbox
                            checked={selected?.resources ? selected.resources.includes(r.id) : false}
                            name={r.id}
                            onChange={this.handleResourceChange}
                          />
                        }
                        label={r.displayName}
                      />
                    ))}
                  </MuiFormGroup>
                </FormControl>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={this.toggleResources}>
                Sulje
              </Button>
            </ModalFooter>
          </Modal>

          {/* Sports modal */}
          <Modal isOpen={this.state.showSportsModal} toggle={this.toggleSports} size='lg'>
            <ModalHeader toggle={this.toggleSports}>Lajit</ModalHeader>
            <ModalBody>
              <p>Valitse yksi tai useampi laji. Tyhjä valinta = kaikki lajit.</p>
              <Autocomplete
                multiple
                options={DEFAULT_SPORTS}
                getOptionLabel={(o) => o.label}
                isOptionEqualToValue={(o, v) => o.key === v.key}
                value={selectedSports}
                onChange={this.handleSportsChange}
                renderInput={(params) => (
                  <TextField {...params} variant='standard' label='Lajit' placeholder='Lisää laji' fullWidth />
                )}
              />
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={this.toggleSports}>
                Sulje
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </>
    )
  }
}

export default FirstPurchaseMessageTemps
